// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".iti[data-v-79a29222]{width:100%}.iti div[data-v-79a29222]{font-size:16px;font-weight:400}.iti .iti__dropdown-content[data-v-79a29222]{background:var(--modal-bg);border-color:transparent}.iti .iti__dropdown-content span[data-v-79a29222]{color:var(--color-gray-800)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
